<template>
  <span class="sort">
    <svg
      class="sort__up ascending"
      width="8"
      height="4"
      viewBox="0 0 8 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      v-if="status === 'up'"
    >
      <path d="M4 0L0 4H8L4 0Z" fill="#C2C2D6"></path>
    </svg>
    <svg
      class="sort__down"
      width="8"
      height="4"
      viewBox="0 0 8 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      v-if="status === 'down'"
    >
      <path d="M4 4L0 0H8L4 4Z" fill="#C2C2D6"></path>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
    },
  },
}
</script>

<style lang="scss"></style>
